module.exports = __webpack_public_path__ + "img/maoimg.c18bd041.png";